import { Firm, OpeningHour } from '@eo-storefronts/eo-core'
import { useEffect, useState } from 'react'
import { buildOpeningHoursString } from '~/src/services/OpeningHourService'

export interface GroupedOpeningHours {
  days: string,
  openingHours: string,
}

const useGroupOpeningHours = (location: Firm): GroupedOpeningHours[] => {
  const [ plainGrouped, setPlainGrouped ] = useState<GroupedOpeningHours[]>([])

  useEffect(() => {
    const { opening_hours: openingHours } = location.settings.periods
    const groupedDays: Record<string, string[]> = {}

    openingHours?.forEach(
      (openingHour: OpeningHour) => {
        const openingHourString = buildOpeningHoursString(openingHour)

        groupedDays[openingHourString] ||= []
        groupedDays[openingHourString].push(openingHour.day)
      }
    )

    const grouped: GroupedOpeningHours[] = []

    for (const openingHourString in groupedDays) {
      grouped.push({
        days: groupedDays[openingHourString].join(' '),
        openingHours: openingHourString
      })
    }

    setPlainGrouped(grouped)
  }, [])

  return plainGrouped
}

export {
  useGroupOpeningHours
}
